import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {
  headerCalculatorRatingRow,
  headerProductRatingRow,
  headerWeekliesRatingRow
} from "../../configs/pc-rating-modal-config";
import {ProductCardRatingWeekly} from "../../types/pc-rating-modal.types";
import {ScrollSyncDirective} from "../../../../../../../../shared/directives/scroll-sync.directive";

@Component({
  selector: 'app-pc-rating-header',
  standalone: true,
  imports: [
    ScrollSyncDirective
  ],
  templateUrl: './pc-rating-header.component.html',
  styleUrl: './pc-rating-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PcRatingHeaderComponent {
  weeklyCount = input<number>(0);
  ratingData = input<Array<ProductCardRatingWeekly>>([]);

  public readonly headerCalculatorRatingRow = headerCalculatorRatingRow;
  public readonly headerProductRatingRow = headerProductRatingRow;
  public readonly headerWeekliesRatingRow = headerWeekliesRatingRow;

  public get weeklyColumns(): Array<number> {
    return Array(this.weeklyCount()).fill(0).map((_, i) => i).reverse();
  }

  public getDateRangeValue(index: number): string {
    const data = this.ratingData().at(0)?.weeklyRatings?.at(index);
    return `${data?.dateFrom} - ${data?.dateTo}`;
  }
}
